import { publicRoutes } from "./publicRoutes";

export const isPublicRoute = (pathname) => {
  return publicRoutes.some((route) => pathname.startsWith(route));
};
